import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { businessReducer } from './business.slice';
import { transactionsReduce } from './transactions.slice';
import { productsReducer } from './products.slice';
import { businessUserReducer } from './businessUser.slice';
import { salesReportReducer } from './salesReport.slice';
import { salesSlice } from './sales.slice';

export const store = configureStore({
  reducer: {
    business: businessReducer,
    businessUser: businessUserReducer,
    transactions: transactionsReduce,
    products: productsReducer,
    salesReport: salesReportReducer,
    sales: salesSlice.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
